// extracted by mini-css-extract-plugin
module.exports = {"pending-status-container":"_3LQNskkzTu2CcuF4ukdSbY","pending":"_30-3C8X9l49W_Z_wLmppUy","resend":"j4aM6Xjgmv7pfkHralXAl","is-resend":"YoKmE-AyArKlnSiG-OqEp"};